import * as z from "zod/v4";
import { ONBOARDING_V2_STATUSES, PRODUCT_IDS } from "./initialize";

export const MAX_ANALYTICS_SESSION_ID_LENGTH = 255;

export const saveProgress = {
  name: "saveProgress" as const,
  input: z.object({
    productId: z.enum(PRODUCT_IDS),
    currentStepId: z.string(),
    sourceStepId: z.string().optional(),
    stepData: z.record(z.string(), z.unknown()).optional(),
    analyticsSessionId: z
      .string()
      .trim()
      .max(MAX_ANALYTICS_SESSION_ID_LENGTH)
      .optional(),
    timeSpentMs: z.number().optional(),
    status: z.enum(ONBOARDING_V2_STATUSES).optional(),
    dealSize: z.number().optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
};
